module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAACeBAMAAAAs+VKWAAAAHlBMVEVHcEz/6uD+6OH+6eL//O7/8tH/57P/3pn/1oP81NTCZ7K9AAAABHRSTlMAG2CoHhBqdgAAAQlJREFUeAHt0bViw1AMhWE5eYAyTWWayrQVZMd7cA/uwT20BqY+bUnXhclSV58/DJ8v0UfePqu7XCT6Mtds6EXUAZt6/jQpNrZjHkiG8tiVr8VUYdcipVkqjuNQr83SOa3Km2DEsTXcWE/RkuqsaBQtSg7JH2hQmJOjIvmYqWhQ0JJXh0JWNfiDijrU/o0KHR3qVn9QcVTVoUKjHSF/xOoaOYdKOT3yhw512FDdoYEFhYL8lgVlcl8oqFhQUAECAgICAgICAgICAgICAgICAgICSix6/UdAQEBAiUMPdjOnUzua0ZYdTSltR+fk2dEi2Rc1I6KUFe0QmYea0Wee6ajmiyRqX28uP807cJbxuZ912iEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/sign-item-bg1.png
// module id = 73mF
// module chunks = 212